import { useQuery } from '@tanstack/react-query'

import { apiClient } from '../apiClient'

export const ADDRESS_LOOKUP_KEY = 'address-lookup'

type AddressLookupRequest = {
  zipcode?: string
  address?: string
}

type AddressLookupResponse = {
  city: string
  state: string
}

export function useGetAddress(params?: AddressLookupRequest) {
  return useQuery({
    queryKey: [ADDRESS_LOOKUP_KEY, params],
    queryFn: async () =>
      (await apiClient.get<AddressLookupResponse>(`/int/user_profile/address_lookup`, { params })).data,
    refetchOnWindowFocus: false,
    retry: false,
    enabled:
      Boolean(params?.address && params?.zipcode) &&
      params?.address !== '' &&
      params?.zipcode !== '' &&
      params?.zipcode?.length === 5,
  })
}
